import React from 'react'
import './experience.css'
import Experiencebars from './experiencebars.jsx'
import experiencedata from '../../experiencedata.js'

const Experience = () => {    
  return (
    <section id="experiences">
        <span className="experienceTitle">My Experience</span>
        {/* <span className="experienceDesc">I am a experienceed and passionate web designer with experience in creating visualizing</span> */}
        <div className="experienceBars">
            {experiencedata.map((item, index)=>{          
                return <Experiencebars 
                    key={item.id || index}
                    img={item.img}
                    alt={item.alt || item.name}
                    name={item.name}
                    time={item.time}
                    content={item.content}/>
            })}
            {/* {data.map((item,index) => (
                <div className="experienceBar" key={item.id || index}>
                    <img src={item.img} alt={item.alt} className="experienceBarImg" />
                    <div className="experienceBarText">
                        <h2>{item.name}</h2>
                        <p>{item.content}</p>
                    </div>
                </div>
            ))} */}
        </div>
    </section>
  )
}

export default Experience
